import ReactSlider from 'react-slider';
import { styled } from '@withjoy/joykit/theme';

import { pxToRem } from '@withjoy/joykit/theme';

type StyledSliderProps = Readonly<{
  min: number;
  max: number;
  className: string;
  trackClassName: string;
  thumbClassName: string;
  value: readonly [number, number];
  onChange: (value: number | readonly number[], index: number) => void;
  /** Optional active-track color override (e.g. the cash-fund gold); defaults to the brand color. */
  $activeColor?: string;
}>;

export const StyledSlider = styled(ReactSlider as React.ComponentType<StyledSliderProps>)(({ theme, $activeColor }) => ({
  width: '100%',
  height: pxToRem(24),
  maxWidth: pxToRem(372),

  '.track': {
    top: '50%',
    height: pxToRem(4),
    borderRadius: pxToRem(2),
    transform: 'translateY(-50%)',
    background: theme.colors.mono5,
  },

  '.track-1': {
    background: $activeColor ?? theme.colors.newUITest1,
  },

  '.thumb': {
    top: '50%',
    outline: 'none',
    cursor: 'pointer',
    width: pxToRem(24),
    height: pxToRem(24),
    borderRadius: '50%',
    transform: 'translate(0%, -50%)',
    background: theme.colors.white,
    boxShadow: `0 ${pxToRem(3)} ${pxToRem(3)} rgba(0, 0, 0, 0.1)`,

    '&:hover': {
      boxShadow: `0 ${pxToRem(4)} ${pxToRem(4)} rgba(0, 0, 0, 0.2)`,
    },
  },
}));
